import axios from "axios";

const EMPRESA_URL =
  `${process.env.REACT_APP_API_URL}/empresa` ||
  "http://localhost:3001/api/empresa";

export async function getEmpresa(token) {
  const headers = {
    authorization: token,
  };
  const response = await axios.get(EMPRESA_URL, { headers });
  return response.data;
}

export async function updateEmpresa(newData, token) {
  const headers = { authorization: token };
  const response = await axios.patch(EMPRESA_URL, newData, { headers });
  return response.data;
}
